// src/grapes/config/traits.ts
import { TraitManagerConfig } from 'grapesjs';

export const traitsConfig: Partial<TraitManagerConfig> = {};
